module.exports = __webpack_public_path__ + "media/images/front/icon_dba_300-a183dde20782aef7bd9e059956ac9aa8.jpg";